// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"kaa-z","narrowOptionButtons":"laa-z","noOptions":"maa-z"};